interface PageDefinition<T> {
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  route: string;
  getPath: (paramObj: [T] extends [string] ? Record<T, string> : void) => string;
}

export class Page<T> implements PageDefinition<T> {
  readonly component: React.LazyExoticComponent<React.ComponentType<any>>;

  readonly route: string;

  constructor({ component, route }) {
    this.component = component;
    this.route = route;
  }

  /**
   * @param paramObj An object containing key/value pairs for each route param
   * @returns A path that is usable in history.push(PATH) or internal links/redirects
   **/
  getPath(paramObj: [T] extends [string] ? Record<T, string> : void): string;
  getPath(paramObj: Record<string, string> | void): string {
    let path: string = this.route;

    if (!paramObj) {
      return path;
    }

    Object.keys(paramObj).forEach((param: string) => {
      path = path.replace(`:${param}`, encodeURIComponent(paramObj[param]));
    });

    return path;
  }
}
